import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BusyService {
  readonly isBusy = signal(false);

  show(): void {
    this.isBusy.set(true);
  }

  hide(): void {
    this.isBusy.set(false);
  }
}
